
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34252',
  depVersions: {
  "documents-public-ui": "static-1.34252",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34257",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2029",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5494",
  "hs-test-utils": "static-1.7911",
  "hub-http": "static-1.6119",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11354",
  "I18n": "static-7.1603",
  "jasmine-immutable": "static-1.2917",
  "jasmine-runner": "static-1.6369",
  "lodash": "static-1.3",
  "quartz": "static-1.6869",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16556",
  "reporting-data": "static-1.67030",
  "reporting-testing-lib": "static-1.8963",
  "reporting-visualizations": "static-1.59106",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4669",
  "webpack-env": "static-1.54",
  "atom": "static-1.4971",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2394",
  "classnames": "static-2.10",
  "cssUtils": "static-1.769",
  "customer-data-filters-ui": "static-1.39363",
  "customer-data-objects": "static-1.7559",
  "customer-data-property-utils": "static-1.7984",
  "data-fetching-client": "static-1.9575",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4429",
  "flux-actions": "static-1.325",
  "FormsCommonComponents": "static-1.85579",
  "FormUrlGenerator": "static-2.4619",
  "foundations-components": "static-1.7724",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11662",
  "icons": "static-2.639",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7059",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3753",
  "property-translator": "static-1.5308",
  "quartz-config": "static-1.647",
  "quartz-core": "static-1.6088",
  "quick-fetch": "static-1.3835",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5267",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8067",
  "reference-resolvers-lite": "static-1.7989",
  "report-customization-components": "static-1.12838",
  "reporting-enablement": "static-1.22511",
  "reporting-reports": "static-1.66708",
  "reporting-snowflake": "static-1.55648",
  "reporting-ui-components": "static-2.64301",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4544",
  "sales-content-partitioning": "static-1.8837",
  "SalesContentIndexUI": "static-3.9089",
  "sanitize": "static-1.4373",
  "sanitize-text": "static-1.8045",
  "self-service-api": "static-1.10145",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1651",
  "signup-constants": "static-1.18661",
  "signup-ui-lego-core": "static-1.20671",
  "signup-ui-url-generator": "static-2.7941",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4669",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10891",
  "ui-addon-i18n": "static-1.11047",
  "ui-addon-react-router-dom": "static-1.9444",
  "ui-addon-upgrades": "static-9.17843",
  "ui-asset-management-lib": "static-1.10883",
  "ui-images": "static-2.1129",
  "UIComponents": "static-3.8301",
  "usage-tracker": "static-1.7236",
  "usage-tracker-container": "static-1.7226",
  "usage-tracker-core": "static-1.7086",
  "usage-tracker-public": "static-1.7047",
  "viral-links-lib": "static-1.6942",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3325",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3146",
  "quartz-webpack": "static-1.3093",
  "ai-components-ui-library": "static-1.8685",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4748",
  "foundations-theming": "static-1.4313",
  "quartz-auth": "static-1.544",
  "ui-business-units-lib": "static-1.8941",
  "usage-tracker-session-replay": "static-1.4922",
  "foundations-theming-base": "static-1.3298",
  "HeadJS": "static-2.735",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3022",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4224",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7824",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3508",
  "persist-promise": "static-1.3609",
  "reporting-client-types": "static-1.2427",
  "foundations-components-legacy": "static-1.749",
  "hs-story-utils": "static-1.9330",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9734",
  "hubspotter-http": "static-1.4571",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7150",
  "crm-message-bus": "static-1.42702",
  "customer-data-filters-ui-msw-helpers": "static-1.21798",
  "customer-data-objects-ui-components": "static-1.12919",
  "customer-data-reference-ui-components": "static-1.13054",
  "customer-data-ui-utilities": "static-1.9725",
  "framework-builder-read-service-client": "static-1.3927",
  "framework-data-schema-quick-fetch": "static-1.6680",
  "framework-data-schema-resolvers": "static-1.6775",
  "inbound-db-properties-service-client": "static-1.3765",
  "multi-account-reference-resolvers": "static-1.874",
  "onboarding-tours": "static-1.16419",
  "reporting-datasets-permissions-lib": "static-1.13387",
  "ui-addon-teams": "static-1.21412",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68048",
  "customer-data-properties": "static-1.51194",
  "forms-ai-lib": "static-1.4162",
  "forms-utils-lib": "static-1.12392",
  "foundations-components-test-utils": "static-1.5207",
  "react-dnd-compat": "static-1.4518",
  "react-tinymce": "static-1.54953",
  "tinymce-config": "static-2.54079",
  "ui-gdpr-components": "static-1.10248",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3993",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1532",
  "ui-fonts": "static-1.616",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.819",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.534",
  "quartz-i18n": "static-1.544",
  "quartz-routing": "static-1.299",
  "quartz-test": "static-1.544",
  "quartz-tracking": "static-1.248",
  "batch-promise": "static-1.1452",
  "external-options-client-types": "static-1.4077",
  "react-colorpicker": "static-2.10109",
  "copilot-toolkit": "static-1.10847",
  "data-quality-ui-library": "static-1.12611",
  "html-to-image": "static-1.52",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6364",
  "reporting-action-components": "static-1.40976",
  "reporting-insights-lib": "static-1.1415",
  "reporting-plugins": "static-1.10138",
  "ui-addon-draggable-compat": "static-2.4154",
  "ui-addon-opt": "static-4.8282",
  "ui-shepherd-react": "static-3.10047",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25064",
  "hubspot-apollo-client": "static-1.4778",
  "chirp-fetch": "static-1.1781",
  "sales-templates-service-types-lib": "static-1.4086",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5683",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.3997",
  "nested-table": "static-1.125",
  "timezone-utils": "static-2.5144",
  "bender-build-tools": "static-1.3063",
  "chatspot-core": "static-1.20817",
  "bend-plugin-foundations-theming": "static-1.2796",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9732",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3716",
  "crm-pipelines-api-client-types": "static-1.4061",
  "multi-currency-client-types": "static-1.3609",
  "getting-started-shared-tasks": "static-1.18212",
  "growth-data-modal": "static-1.5276",
  "growth-onboarding-confetti": "static-1.2971",
  "growth-onboarding-next-action-utils": "static-1.1619",
  "navigation-components": "static-1.17657",
  "onboarding-tours-client": "static-1.4633",
  "onboarding-tours-utils": "static-1.485",
  "ui-shepherd-tracker": "static-1.7428",
  "ui-universal-auth": "static-1.8837",
  "user-context": "static-1.5000",
  "cms-field-types": "static-1.4709",
  "content-icons-ui": "static-1.2202",
  "integrations-lib": "static-1.15791",
  "calling-global-api": "static-1.64105",
  "calling-internal-common": "static-1.31201",
  "calling-lifecycle-internal": "static-1.65487",
  "calling-lifecycle-messages": "static-1.57781",
  "commerce-products-lib": "static-1.9159",
  "crm-links": "static-1.6176",
  "customer-data-properties-shared-msw-handlers": "static-1.9061",
  "file-manager-components": "static-1.23303",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4142",
  "meetings-icalendar-utils-lib": "static-1.530",
  "object-builder-ui-client": "static-1.48401",
  "pipeline-validation-client-types": "static-1.3884",
  "property-value-citations": "static-1.1808",
  "pulse": "static-1.443",
  "smart-property-lib": "static-1.6450",
  "tiered-pricing": "static-1.1014",
  "ui-addon-iframeable": "static-1.8950",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19658",
  "tinymce-themes": "static-1.56049",
  "data-token-picker": "static-1.16229",
  "hub-http-contrib": "static-1.2943",
  "interframe": "static-3.4663",
  "tinymce-data": "static-1.40164",
  "tinymce-plugins": "static-1.57193",
  "ui-addon-sales-email": "static-1.5111",
  "magpie-lib": "static-1.5493",
  "magpie-types": "static-1.4953",
  "simple-logging-lib": "static-1.2951",
  "content-assistance-lib": "static-1.7605",
  "dashboard-lib": "static-1.81100",
  "ExportDialog": "static-6.10290",
  "hubspot-prosemirror": "static-1.17947",
  "hubspot-prosemirror-plugins": "static-1.17939",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8595",
  "campaign-roi-lib": "static-1.8650",
  "feedback-loader": "static-1.29109",
  "apollo-link-hub-http": "static-2.4551",
  "hubspot-apollo-cache": "static-1.237",
  "growth-monetization-service-types": "static-1.4402",
  "nav-client-types": "static-1.2258",
  "purchase-motions-api": "static-1.5686",
  "react-window": "static-1.13",
  "onboarding-data-sync-lib": "static-1.1793",
  "growth-onboarding-next-action-components": "static-1.1647",
  "user-context-client": "static-1.4512",
  "idb-keyval": "static-1.42",
  "nest": "static-1.122",
  "reactive-lib": "static-1.624",
  "unified-auth-core-lib": "static-1.632",
  "getting-started-shared-tasks-store": "static-1.17330",
  "integrations-error-boundary-lib": "static-1.13206",
  "integrations-tracking-lib": "static-1.5496",
  "native-integrations-shared-strings": "static-1.7686",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10274",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.351",
  "calling-error-reporting": "static-1.31207",
  "shared-worker-versioning": "static-1.10938",
  "calling-usage-tracker": "static-1.6441",
  "voice-sms-access-library": "static-1.604",
  "customer-data-tracking": "static-1.6784",
  "commerce-permissions": "static-1.665",
  "products-iframe-lib": "static-1.7646",
  "products-ui-components-shared-msw-handlers": "static-1.10116",
  "location-customization-utils-lib": "static-1.8922",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4053",
  "video-components-external": "static-1.10952",
  "video-data-lib": "static-1.34610",
  "directed-graph": "static-1.837",
  "event-emitter": "static-1.848",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.37",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9817",
  "fsm": "static-1.3634",
  "policy-lib": "static-1.6684",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9880",
  "navigation-messaging": "static-1.6984",
  "FileManagerLib": "static-1.38943",
  "NamespacedHubStyle": "static-2.8988",
  "FileManagerCore": "static-1.38802",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12251",
  "layout-dnd-utils": "static-1.11226",
  "react-codemirror": "static-1.10524",
  "ui-addon-emoji-picker": "static-1.9787",
  "ui-brand-identity-lib": "static-1.14794",
  "ui-addon-video-player": "static-1.8596",
  "ui-coaching-tips": "static-1.28260",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8444",
  "payment-link-components": "static-1.23246",
  "EmailSignatureEditor": "static-1.24155",
  "eligibility-engine-service-types": "static-1.3084",
  "InboxConnectUtils": "static-4.14532",
  "universal-page-editor-lib": "static-1.2907",
  "microsoft-drive-integration-lib": "static-1.24",
  "calling-orchestration-schema": "static-1.35381",
  "sales-views-client-types": "static-1.4163",
  "crm-record-cards-service-types": "static-1.3529",
  "content-media-composition-data-lib": "static-1.11909",
  "content-media-compositions": "static-2.15916",
  "media-bridge-lib": "static-1.18749",
  "trellis-story-utils": "static-1.4419",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5766",
  "FileManagerImages": "static-1.36454",
  "video-components": "static-1.12955",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4432",
  "video-embed": "static-1.35444",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68123",
  "layout-data-lib": "static-1.9551",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6482",
  "commerce-tours-lib": "static-1.5910",
  "growth-onboarding-reliability": "static-1.4986",
  "sales-checkout-service-client": "static-1.3568",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21498",
  "sales-email-signature-service-client": "static-1.3743",
  "social-insights-client-types": "static-1.21786",
  "outpost": "static-1.4095",
  "advanced-menus-core": "static-1.14974",
  "advanced-menus-lib": "static-1.11936",
  "ui-memberships-settings-lib": "static-1.33766",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14973",
  "simple-menus-lib": "static-1.16490"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34252",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34257",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2029",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5494",
  "hs-test-utils": "/hs-test-utils/static-1.7911",
  "hub-http": "/hub-http/static-1.6119",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11354",
  "I18n": "/I18n/static-7.1603",
  "jasmine-immutable": "/jasmine-immutable/static-1.2917",
  "jasmine-runner": "/jasmine-runner/static-1.6369",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6869",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16556",
  "reporting-data": "/reporting-data/static-1.67030",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8963",
  "reporting-visualizations": "/reporting-visualizations/static-1.59106",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4669",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4971",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2394",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.769",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39363",
  "customer-data-objects": "/customer-data-objects/static-1.7559",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7984",
  "data-fetching-client": "/data-fetching-client/static-1.9575",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4429",
  "flux-actions": "/flux-actions/static-1.325",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85579",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4619",
  "foundations-components": "/foundations-components/static-1.7724",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11662",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7059",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3753",
  "property-translator": "/property-translator/static-1.5308",
  "quartz-config": "/quartz-config/static-1.647",
  "quartz-core": "/quartz-core/static-1.6088",
  "quick-fetch": "/quick-fetch/static-1.3835",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5267",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8067",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7989",
  "report-customization-components": "/report-customization-components/static-1.12838",
  "reporting-enablement": "/reporting-enablement/static-1.22511",
  "reporting-reports": "/reporting-reports/static-1.66708",
  "reporting-snowflake": "/reporting-snowflake/static-1.55648",
  "reporting-ui-components": "/reporting-ui-components/static-2.64301",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4544",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8837",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9089",
  "sanitize": "/sanitize/static-1.4373",
  "sanitize-text": "/sanitize-text/static-1.8045",
  "self-service-api": "/self-service-api/static-1.10145",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1651",
  "signup-constants": "/signup-constants/static-1.18661",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20671",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7941",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4669",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10891",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11047",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9444",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17843",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10883",
  "ui-images": "/ui-images/static-2.1129",
  "UIComponents": "/UIComponents/static-3.8301",
  "usage-tracker": "/usage-tracker/static-1.7236",
  "usage-tracker-container": "/usage-tracker-container/static-1.7226",
  "usage-tracker-core": "/usage-tracker-core/static-1.7086",
  "usage-tracker-public": "/usage-tracker-public/static-1.7047",
  "viral-links-lib": "/viral-links-lib/static-1.6942",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3325",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3146",
  "quartz-webpack": "/quartz-webpack/static-1.3093",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8685",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4748",
  "foundations-theming": "/foundations-theming/static-1.4313",
  "quartz-auth": "/quartz-auth/static-1.544",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8941",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4922",
  "foundations-theming-base": "/foundations-theming-base/static-1.3298",
  "HeadJS": "/HeadJS/static-2.735",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3022",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4224",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7824",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3508",
  "persist-promise": "/persist-promise/static-1.3609",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.749",
  "hs-story-utils": "/hs-story-utils/static-1.9330",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9734",
  "hubspotter-http": "/hubspotter-http/static-1.4571",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7150",
  "crm-message-bus": "/crm-message-bus/static-1.42702",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21798",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12919",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13054",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9725",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3927",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6680",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6775",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3765",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.874",
  "onboarding-tours": "/onboarding-tours/static-1.16419",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13387",
  "ui-addon-teams": "/ui-addon-teams/static-1.21412",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68048",
  "customer-data-properties": "/customer-data-properties/static-1.51194",
  "forms-ai-lib": "/forms-ai-lib/static-1.4162",
  "forms-utils-lib": "/forms-utils-lib/static-1.12392",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5207",
  "react-dnd-compat": "/react-dnd-compat/static-1.4518",
  "react-tinymce": "/react-tinymce/static-1.54953",
  "tinymce-config": "/tinymce-config/static-2.54079",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10248",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3993",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1532",
  "ui-fonts": "/ui-fonts/static-1.616",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.819",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.534",
  "quartz-i18n": "/quartz-i18n/static-1.544",
  "quartz-routing": "/quartz-routing/static-1.299",
  "quartz-test": "/quartz-test/static-1.544",
  "quartz-tracking": "/quartz-tracking/static-1.248",
  "batch-promise": "/batch-promise/static-1.1452",
  "external-options-client-types": "/external-options-client-types/static-1.4077",
  "react-colorpicker": "/react-colorpicker/static-2.10109",
  "copilot-toolkit": "/copilot-toolkit/static-1.10847",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12611",
  "html-to-image": "/html-to-image/static-1.52",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6364",
  "reporting-action-components": "/reporting-action-components/static-1.40976",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1415",
  "reporting-plugins": "/reporting-plugins/static-1.10138",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4154",
  "ui-addon-opt": "/ui-addon-opt/static-4.8282",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10047",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25064",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4778",
  "chirp-fetch": "/chirp-fetch/static-1.1781",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4086",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5683",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.3997",
  "nested-table": "/nested-table/static-1.125",
  "timezone-utils": "/timezone-utils/static-2.5144",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "chatspot-core": "/chatspot-core/static-1.20817",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2796",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9732",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3716",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4061",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3609",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18212",
  "growth-data-modal": "/growth-data-modal/static-1.5276",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2971",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1619",
  "navigation-components": "/navigation-components/static-1.17657",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4633",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.485",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7428",
  "ui-universal-auth": "/ui-universal-auth/static-1.8837",
  "user-context": "/user-context/static-1.5000",
  "cms-field-types": "/cms-field-types/static-1.4709",
  "content-icons-ui": "/content-icons-ui/static-1.2202",
  "integrations-lib": "/integrations-lib/static-1.15791",
  "calling-global-api": "/calling-global-api/static-1.64105",
  "calling-internal-common": "/calling-internal-common/static-1.31201",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65487",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57781",
  "commerce-products-lib": "/commerce-products-lib/static-1.9159",
  "crm-links": "/crm-links/static-1.6176",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9061",
  "file-manager-components": "/file-manager-components/static-1.23303",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4142",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.530",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48401",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3884",
  "property-value-citations": "/property-value-citations/static-1.1808",
  "pulse": "/pulse/static-1.443",
  "smart-property-lib": "/smart-property-lib/static-1.6450",
  "tiered-pricing": "/tiered-pricing/static-1.1014",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8950",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19658",
  "tinymce-themes": "/tinymce-themes/static-1.56049",
  "data-token-picker": "/data-token-picker/static-1.16229",
  "hub-http-contrib": "/hub-http-contrib/static-1.2943",
  "interframe": "/interframe/static-3.4663",
  "tinymce-data": "/tinymce-data/static-1.40164",
  "tinymce-plugins": "/tinymce-plugins/static-1.57193",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5111",
  "magpie-lib": "/magpie-lib/static-1.5493",
  "magpie-types": "/magpie-types/static-1.4953",
  "simple-logging-lib": "/simple-logging-lib/static-1.2951",
  "content-assistance-lib": "/content-assistance-lib/static-1.7605",
  "dashboard-lib": "/dashboard-lib/static-1.81100",
  "ExportDialog": "/ExportDialog/static-6.10290",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17947",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17939",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8595",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8650",
  "feedback-loader": "/feedback-loader/static-1.29109",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4551",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.237",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4402",
  "nav-client-types": "/nav-client-types/static-1.2258",
  "purchase-motions-api": "/purchase-motions-api/static-1.5686",
  "react-window": "/react-window/static-1.13",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1793",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1647",
  "user-context-client": "/user-context-client/static-1.4512",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.122",
  "reactive-lib": "/reactive-lib/static-1.624",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.632",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17330",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13206",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5496",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7686",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10274",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.351",
  "calling-error-reporting": "/calling-error-reporting/static-1.31207",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10938",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6441",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.604",
  "customer-data-tracking": "/customer-data-tracking/static-1.6784",
  "commerce-permissions": "/commerce-permissions/static-1.665",
  "products-iframe-lib": "/products-iframe-lib/static-1.7646",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10116",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8922",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4053",
  "video-components-external": "/video-components-external/static-1.10952",
  "video-data-lib": "/video-data-lib/static-1.34610",
  "directed-graph": "/directed-graph/static-1.837",
  "event-emitter": "/event-emitter/static-1.848",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.37",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9817",
  "fsm": "/fsm/static-1.3634",
  "policy-lib": "/policy-lib/static-1.6684",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9880",
  "navigation-messaging": "/navigation-messaging/static-1.6984",
  "FileManagerLib": "/FileManagerLib/static-1.38943",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8988",
  "FileManagerCore": "/FileManagerCore/static-1.38802",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12251",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11226",
  "react-codemirror": "/react-codemirror/static-1.10524",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9787",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14794",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8596",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28260",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8444",
  "payment-link-components": "/payment-link-components/static-1.23246",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24155",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3084",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14532",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2907",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.24",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35381",
  "sales-views-client-types": "/sales-views-client-types/static-1.4163",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3529",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11909",
  "content-media-compositions": "/content-media-compositions/static-2.15916",
  "media-bridge-lib": "/media-bridge-lib/static-1.18749",
  "trellis-story-utils": "/trellis-story-utils/static-1.4419",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5766",
  "FileManagerImages": "/FileManagerImages/static-1.36454",
  "video-components": "/video-components/static-1.12955",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4432",
  "video-embed": "/video-embed/static-1.35444",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68123",
  "layout-data-lib": "/layout-data-lib/static-1.9551",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6482",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5910",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4986",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3568",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21498",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3743",
  "social-insights-client-types": "/social-insights-client-types/static-1.21786",
  "outpost": "/outpost/static-1.4095",
  "advanced-menus-core": "/advanced-menus-core/static-1.14974",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11936",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33766",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14973",
  "simple-menus-lib": "/simple-menus-lib/static-1.16490"
}
};
